import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { type ReactNode, type JSX } from 'react';
interface AuthRequiredLayoutProps {
  children: ReactNode;
}
const AuthRequiredLayout = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Head><meta name="robots" content="noindex" /></Head>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <>{t1}{children}</>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default AuthRequiredLayout;